<template>
  <div>
    <el-dialog title="提醒人设置" :visible.sync="show" width="70%" appendToBody :before-close="close" :close-on-click-modal="false" destory-on-close top="8vh">
      <el-container>
        <el-main style="padding: 10px; height: 530px">
          <form v-form>
            <table class="table table-bordered" style="border-spacing: 0; width: 100%; max-height: 400px; overflow: initial">
              <thead>
                <th style="width: 15%">权限类型</th>
                <th>内容</th>
                <th style="width: 15%">操作</th>
              </thead>
              <tbody>
                <tr v-for="(item, $index) in needSetArr" :key="item.title" :data-index="$index" data-subname="needSetArr">
                  <th>{{ item.title }}</th>
                  <td>
                    <eip-user-selector v-if="item.type == 'user'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipRoleSelector v-if="item.type == 'role'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipJobSelector v-if="item.type == 'job'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipPostSelector v-if="item.type == 'pos'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                  </td>
                  <td>
                    <el-button @click="updateNeedSetArr($index)">重置</el-button>
                  </td>
                </tr>
                <tr>
                  <th>表单字段</th>
                  <td>
                    <el-select v-model="formfield" multiple placeholder="请选择" @change="formfieldChange" filterable>
                      <el-option v-for="item in formfieldOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                    </el-select>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>施工人员动态岗位</th>
                  <td>
                    <el-select v-model="conPerson" multiple placeholder="请选择" @change="changeConPerson" filterable>
                      <el-option v-for="item in conPersonOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                    </el-select>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>设计人员动态岗位</th>
                  <td>
                    <el-select v-model="designPerson" multiple placeholder="请选择" @change="changeDesignPerson" filterable>
                      <el-option v-for="item in designPersonOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                    </el-select>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>脚本</th>
                  <td>
                    <el-select v-model="jsScript" multiple placeholder="请选择" @change="changeJsList" filterable style="width: 600px">
                      <el-option v-for="item in jsListOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                    </el-select>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </form>
        </el-main>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose" size="medium">确 定</el-button>
        <el-button @click="close" size="medium">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils'

const eipUserSelector = () => import('@/components/selector/EipUserSelector.vue')
const eipRoleSelector = () => import('@/components/selector/EipRoleSelector.vue')
const eipPostSelector = () => import('@/components/selector/EipPostSelector.vue')
const eipJobSelector = () => import('@/components/selector/EipJobSelector.vue')

export default {
  components: {
    eipUserSelector,
    eipRoleSelector,
    eipPostSelector,
    eipJobSelector
  },
  props: {
    show: { type: Boolean, default: () => false },
    boKey: { type: String, default: () => '' },
    value: {
      type: Object
    }
  },
  watch: {
    boKey: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.formfieldOptions = []
        if (newVal && newVal != '') {
          this.$http.get('${risk}/rule/business_reminder/getUserByModuleKey?key=' + newVal).then((res) => {
            if (res.data) {
              res.data.forEach((item) => {
                this.formfieldOptions.push({
                  key: item.user_key,
                  name: item.user_name
                })
              })
            }
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  data() {
    return {
      dialogVisible: false,
      showSelectors: {
        user: false,
        org: false,
        pos: false,
        role: false
      },
      needSetArr: [
        {
          type: 'user',
          title: '用户',
          id: '',
          name: ''
        },
        {
          type: 'pos',
          title: '岗位',
          id: '',
          name: ''
        },
        {
          type: 'job',
          title: '职务',
          id: '',
          name: ''
        },

        {
          type: 'role',
          title: '角色',
          id: '',
          name: ''
        }
      ],
      noNeedSetArr: [],
      right: '',
      permissionList: [],
      showNeedRight: true,
      curSelectItem: {},
      autoClose: true,
      selectorKey: 1,
      formfield: [],
      formfieldOptions: [],
      backStr: [],
      conPerson: [],
      conPersonOptions: [],
      designPerson: [],
      designPersonOptions: [],
      jsListOptions: [],
      jsScript: []
    }
  },
  mounted() {
    // this.formfieldOptions = []
    // if (this.boKey && this.boKey != '') {
    //   this.$http.get('${risk}/rule/business_reminder/getUserByModuleKey?key=' + this.boKey).then((res) => {
    //     if (res.data) {
    //       res.data.forEach((item) => {
    //         this.formfieldOptions.push({
    //           key: item.user_key,
    //           name: item.user_name
    //         })
    //       })
    //     }
    //   })
    // }
    this.conPersonOptions = utils.findDictList('zw', this.allDataDict)
    this.designPersonOptions = utils.findDictList('sjxmzw', this.allDataDict)
    this.$http.get('${risk}/rule/business_reminder/getAllRiskUserScript').then((res) => {
      if (res.data) {
        this.jsListOptions = res.data
      }
    })
  },
  methods: {
    bindShowValue(value) {
      this.needSetArr = [
        {
          type: 'user',
          title: '用户',
          id: '',
          name: ''
        },
        {
          type: 'pos',
          title: '岗位',
          id: '',
          name: ''
        },
        {
          type: 'job',
          title: '职务',
          id: '',
          name: ''
        },

        {
          type: 'role',
          title: '角色',
          id: '',
          name: ''
        }
      ]
      this.formfield = []
      this.conPerson = []
      this.designPerson = []
      this.jsScript = []
      this.backStr = []
      if (value && value.length) {
        value.forEach((item) => {
          if (item.customer_type == '1') {
            this.$set(this.needSetArr[0], 'id', item.source_ids)
            this.$set(this.needSetArr[0], 'name', item.source_names)
          }
          if (item.customer_type == '2') {
            this.$set(this.needSetArr[1], 'id', item.source_ids)
            this.$set(this.needSetArr[1], 'name', item.source_names)
          }
          if (item.customer_type == '3') {
            this.$set(this.needSetArr[2], 'id', item.source_ids)
            this.$set(this.needSetArr[2], 'name', item.source_names)
          }
          if (item.customer_type == '4') {
            this.$set(this.needSetArr[3], 'id', item.source_ids)
            this.$set(this.needSetArr[3], 'name', item.source_names)
          }
          if (item.customer_type == '5' && item.source_ids) {
            this.formfield = item.source_ids.split(',')
            this.formfieldChange(this.formfield)
          }
          if (item.customer_type == '6' && item.source_ids) {
            this.conPerson = item.source_ids.split(',')
            this.changeConPerson(this.conPerson)
          }
          if (item.customer_type == '7' && item.source_ids) {
            this.designPerson = item.source_ids.split(',')
            this.changeDesignPerson(this.designPerson)
          }
          if (item.customer_type == '8' && item.source_ids) {
            this.jsScript = item.source_ids.split(',')
            this.changeJsList(this.jsScript)
          }
        })
      }
    },
    close() {
      this.$emit('close')
    },
    closeDialog: function () {
      this.dialogVisible = false
    },
    handleClose: function () {
      let rtn = []
      for (let i = 0; i < this.noNeedSetArr.length; i++) {
        let obj = this.noNeedSetArr[i]
        if (obj.checked) {
          rtn.push(obj)
          if (this.backStr.length > 0) {
            rtn.push.apply(rtn, this.backStr)
          }
          this.$emit('onConfirm', rtn, this.name)
          this.dialogVisible = false
          return rtn
        }
      }
      let setting = this.needSetArr
      for (let i = 0; i < setting.length; i++) {
        let obj = setting[i]
        //设置了值。
        if (obj.id) {
          rtn.push(obj)
        }
      }
      if (this.backStr.length > 0) {
        rtn.push.apply(rtn, this.backStr)
      }
      let str = ''
      let sub_business_reminder_member = []
      if (rtn) {
        rtn.forEach((item) => {
          if (item.type == 'user') {
            item.customer_type = '1'
            item.describe = '指定用户'
          }
          if (item.type == 'job') {
            item.customer_type = '3'
            item.describe = '职务'
          }
          if (item.type == 'pos') {
            item.customer_type = '2'
            item.describe = '岗位'
          }
          if (item.type == 'role') {
            item.customer_type = '4'
            item.describe = '角色'
          }
          if (item.type == 'form') {
            item.customer_type = '5'
            item.describe = '表单字段'
          }
          if (item.type == 'conPerson') {
            item.customer_type = '6'
            item.describe = '施工动态岗位'
          }
          if (item.type == 'designPerson') {
            item.customer_type = '7'
            item.describe = '设计动态岗位'
          }
          if (item.type == 'script') {
            item.customer_type = '8'
            item.describe = '脚本'
          }
          if (item.name) {
            str += item.describe + ':' + item.name + ';'
            sub_business_reminder_member.push({
              customer_type: item.customer_type,
              source_names: item.name,
              source_ids: item.id
            })
          }
        })
        str = str.substring(0, str.length - 1)
      }
      this.$emit('onConfirm', rtn, sub_business_reminder_member, str)
      if (this.autoClose) {
        this.dialogVisible = false
      }
    },
    updateNeedSetArr(index) {
      this.needSetArr[index].id = ''
      this.needSetArr[index].name = ''
      ++this.selectorKey
    },
    // 获取施工动态岗位
    changeConPerson(val) {
      // change 多次触发，每次先清理当前类型的数据
      this.backStr = this.backStr.filter((item) => item.type !== 'conPerson')
      let name = ''
      let id = ''
      if (val) {
        val.forEach((item) => {
          id += item + ','
          this.conPersonOptions.forEach((items) => {
            if (item == items.key) {
              name += items.name + ','
            }
          })
        })
        id = id.substring(0, id.length - 1)
        name = name.substring(0, name.length - 1)
        this.backStr.push({ id: id, name: name, type: 'conPerson' })
      }
    },
    //表单字段绑定
    formfieldChange(val) {
      // change 多次触发，每次先清理当前类型的数据
      this.backStr = this.backStr.filter((item) => item.type !== 'form')
      let name = ''
      let id = ''
      if (val) {
        val.forEach((item) => {
          id += item + ','
          this.formfieldOptions.forEach((items) => {
            if (item == items.key) {
              name += items.name + ','
            }
          })
        })
        id = id.substring(0, id.length - 1)
        name = name.substring(0, name.length - 1)
        this.backStr.push({ id: id, name: name, type: 'form' })
      }
    },
    // 获取设计动态岗位
    changeDesignPerson(val) {
      // change 多次触发，每次先清理当前类型的数据
      this.backStr = this.backStr.filter((item) => item.type !== 'designPerson')
      let name = ''
      let id = ''
      if (val) {
        val.forEach((item) => {
          id += item + ','
          this.designPersonOptions.forEach((items) => {
            if (item == items.key) {
              name += items.name + ','
            }
          })
        })
        id = id.substring(0, id.length - 1)
        name = name.substring(0, name.length - 1)
        this.backStr.push({ id: id, name: name, type: 'designPerson' })
      }
    },
    // 获取脚本
    changeJsList(val) {
      // change 多次触发，每次先清理当前类型的数据
      this.backStr = this.backStr.filter((item) => item.type !== 'script')
      let name = ''
      let id = ''
      if (val) {
        val.forEach((item) => {
          id += item + ','
          this.jsListOptions.forEach((items) => {
            if (item == items.key) {
              name += items.name + ','
            }
          })
        })
        id = id.substring(0, id.length - 1)
        name = name.substring(0, name.length - 1)
        this.backStr.push({ id: id, name: name, type: 'script' })
      }
    }
  }
}
</script>

<style scoped>
div >>> .el-dialog__body {
  padding: 10px;
}

.table > thead > tr > th,
.table > thead > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  border-left: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 8px;
  vertical-align: middle;
}
.table {
  border-bottom: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
}
.filed_body >>> .el-button {
  float: right;
}
</style>
